import type {
  CreateMediaTagRequest,
  MediaTag,
  MediaTagListResponse,
  UpdateMediaTagRequest,
} from "@przezmorze/api-types";
import { przezmorzeApi, throwMessageOnStatus } from "../../../api/api";

export type { MediaTag };

export async function listMediaTags(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<MediaTagListResponse>("/media/tags", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function addMediaTag(name: string, isPopular: boolean, abortSignal?: AbortSignal) {
  const body: CreateMediaTagRequest = { name, isPopular };
  try {
    const response = await przezmorzeApi.post<MediaTag>("/media/tags", body, {
      signal: abortSignal,
    });
    return response.data;
  } catch (err) {
    throwMessageOnStatus(err, 409, "Tag już istnieje");
  }
}

export async function updateMediaTag(id: string, name: string, isPopular: boolean, abortSignal?: AbortSignal) {
  const body: UpdateMediaTagRequest = { name, isPopular };
  const response = await przezmorzeApi.put<MediaTag>(`/media/tags/${id}`, body, {
    signal: abortSignal,
  });
  return response.data;
}

export async function deleteMediaTag(id: string, abortSignal?: AbortSignal) {
  try {
    await przezmorzeApi.delete<void>(`/media/tags/${id}`, {
      signal: abortSignal,
    });
  } catch (err) {
    throwMessageOnStatus(err, 409, "Tag jest w użyciu");
  }
}
